<template>
   
    <div class="w-full mx-auto px-1 overflow-hidden overflow-y-auto">
        <!-- Panel superior -->
        <div class="w-full mx-auto   bg-white shadow-sm  px-4 py-1 rounded-md border border-costeaPrimaryDisabled mt-6">
            <!-- Costo CIF (arriba) -->
            <div class=" mb-4 justify-start flex flex-col py-3">
                <span class=" block text-sm ">Costo CIF</span>
                <span :class="{ skeleton: !dataListo }" class=" block text-2xl font-semibold ">$ {{
                    interNumberFormat(this.calcCostoTotal) }}</span>
            </div>

            <!-- Fila inferior (inputs y resultados) -->
            <div class="grid grid-cols-12 items-center gap-4">
                <!-- Horas hombre -->
                <div class="col-span-3">
                    <label for="horas_hombre" class=" block text-xs text-gray-500 mb-1">Ingresa total de horas hombre
                        (HH)</label>
                    <input id="horas_hombre" type="number" min="0" max="99999" step="0.01" v-model="horas_hombre"
                        :disabled="!dataListo" @change="isVisible = true" :class="{ skeleton: !dataListo }"
                        class=" w-full bg-gray-50  rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-costeaPrimary" />
                </div>

                <!-- Tiempo estándar -->
                <div class="col-span-3">
                    <label for="tiempo_standar" class="block text-xs text-gray-500 mb-1">Tiempo estándar</label>
                    <input id="tiempo_standar" type="number" min="0" max="99999" step="0.000001"
                        v-model="tiempo_standar" :disabled="!dataListo" @change="isVisible = true"
                        :class="{ skeleton: !dataListo }"
                        class=" w-full bg-gray-50  rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-costeaPrimary" />
                </div>

                <button @click="() => { isVisible = false; addCifCalc(); }" v-show="isVisible" type="button"
                class=" col-span-1 ring-4 ring-costeaPrimaryDisabled ring-opacity-30 mx-2 cursor-pointer bg-costeaPrimaryDisabled text-costeaPrimary hover:bg-costeaPrimary hover:text-white rounded-full w-5 h-5 flex justify-center items-center"><i
                    class="ri-check-fill"></i></button>

                <!-- Tasa CIF -->
                <div class="col-span-3 ">
                    <span class="block text-xs text-gray-500">Tasa CIF</span>
                    <span :class="{ skeleton: !dataListo }" class=" block text-lg font-bold ">
                        $ {{ calcCostoTotal ? interNumberFormat((calcCostoTotal / horas_hombre).toFixed(2)) : '0.00' }} <span class="font-semibold text-gray-600 text-sm">por hora</span>  
                    </span>
                    
                </div>

                <!-- Costo CIF por producto -->
                <div class="col-span-3 flex justify-end flex-col text-right">
                    <span class="block text-xs text-gray-500">Costo CIF por producto</span>
                    <span :class="{ skeleton: !dataListo }" class=" block text-lg font-bold">
                        $ {{ calcCostoTotal && horas_hombre > 0 ? interNumberFormat((calcCostoTotal / horas_hombre *
                        tiempo_standar).toFixed(2)) : '0.00' }}
                    </span>
                </div>
            </div>
        </div>

        <!-- Tabla dentro del acordeón -->
        <div class="mt-6">
            <button @click="toggleAccordion"
                class="w-full bg-white py-2 px-4 rounded border border-costeaPrimaryDisabled flex justify-between items-center text-gray-700">
                <span> {{ isAccordionOpen ? 'Ocultar detalle' : 'Ver detalle' }} </span>
                <div class="bg-costeaPrimaryDisabled flex justify-center align-center rounded-full p-2">
                    <svg :class="{ 'rotate-180': isAccordionOpen }"
                        class="w-4 h-4  transition-transform duration-200 text-blue-500 "
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </div>
            </button>
            <transition name="fade">
                <div v-show="isAccordionOpen">
                    <table class="w-full mt-4 overflow-y-auto">
                        <thead class="font-costea text-t12 border-b-2 pb-3 h-10 text-left">
                            <tr>
                                <th></th>
                                <th><span class="mr-4 cursor-pointer text-costeaDarkGray">Nombre del costo</span></th>
                                <th><span class="cursor-pointer text-costeaDarkGray">Costo mensual</span></th>
                            </tr>
                        </thead>
                        <tbody v-for="cif in cifs" :key="cif.index" class="">
                            <tr class="font-costea text-t12 pb-3 h-14">
                                <td></td>
                                <td class="mr-4"><input disabled :value="cif.nombre_costo"
                                        class="bg-white border-gray-100 border-b-2 w-full text-t12 font-costea text-costeaDarkGray py-2 px-2" />
                                </td>
                                <td class="text-right"><input disabled :value="interNumberFormat(cif.costo_mensual)"
                                        class="bg-white border-gray-100 border-b-2 w-full text-t12 font-costea text-costeaDarkGray py-2 px-2" />
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-for="cif in addCif" :key="cif.index">
                            <Cif @removeCif="removeCifHandler" @reloadData="reloadData" />
                        </tbody>
                    </table>
                </div>
            </transition>
        </div>
        
    </div>

</template>

<script>
import Cif from '@/components/productos/Cif/AddCif.vue'
import axios from 'axios'
import { mapState } from 'vuex'
export default {
    name: "CostoCIF",
    components: {
        Cif,
    },
    data: function () {
        return {
            nums: [1, 2, 3, 4],
            selectedDate: '',
            adicional: false,
            date: new Date(),
            addCif: 0,
            cifByProducts: [],
            listaCif: [],
            costo_hora_hombre_cif: [],
            productDataAdmon: [],
            productDataCif: [],
            productData: [],
            productMod: [],
            horas_hombre: 0,
            tiempo_standar: 0,
            isVisible: false,
            cifs: [],
            isAccordionOpen: false,
            dataListo: false,
        }
    },
    computed: {
        ...mapState(['costea']),
        calcCostoTotal() {
            var suma = 0
            this.cifs.forEach(cif => {
                suma += parseInt(cif.costo_mensual)
            });
            return suma
        },
        calcCostoHoraHombre() {
            var costohh = 0;
            this.productMod.forEach(proMod => {
                this.costo_hora_hombre_cif.forEach(chh => {
                    if (chh.id == proMod.mano_obra_directa_id) {
                        costohh += parseFloat(chh.tiempo_standar)
                    }
                })
            })
            return costohh;
        },
        defineHorasHombre() {
            var total
            total = this.horas_hombre;
            return total
        },
        defineTiempoStandar() {
            var total
            total = this.tiempo_standar;
            return total
        }
    },
    methods: {
        toggleAccordion() {
            this.isAccordionOpen = !this.isAccordionOpen;
        },
        getCifs: function () {
            axios
                .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}cif`)
                .then(respuesta => {
                    this.cifs = respuesta.data;
                    this.dataListo = true;
                    console.log(this.cifs)
                }).catch((error) => {
                    if (error) {
                        if (error.status === 401) {
                            this.$router.push('/login')
                        }
                    }
                })
        },
        addCifCalc() {
            axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto/add-cif-calc/${this.$route.params.id}`, { horas_hombre: parseFloat(this.defineHorasHombre), tiempo_standar: parseFloat(this.defineTiempoStandar) })
                .then((response) => {
                    console.log(response)
                    this.reloadData(true)
                }
                ).catch(error => console.log(error));
        },

        interNumberFormat(number) {
            let interNF = new Intl.NumberFormat('es-CO');
            let numberDecimals = parseFloat(number)
            numberDecimals = numberDecimals.toFixed(2)
            return interNF.format(numberDecimals)
        },
        removeCifHandler(value) {
            this.addCif += value
        },
        deleteCif(id) {
            let mods = []
            let prod = this.cifByProducts
            for (var i = 0; i < prod.length; i++) {
                if (prod[i].cif_costo_id != id) {
                    mods.push(prod[i].cif_costo_id)
                } else {
                    continue;
                }
            }
            axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto/cif-add/${this.$route.params.id}`, { cif_costo_id: mods })
                .then(
                    this.reloadData(true),
                ).catch(error => console.log(error));
        },
        getDataToCif() {
            axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
                .then(
                    response => {
                        this.productDataCif = response.data.data.cifcostos;
                        this.productDataAdmon = response.data.data.admongastos;
                        this.productMod = response.data.data.modirectas;
                        this.productData = response.data.data;
                        this.horas_hombre = response.data.data.horas_hombre;
                        this.tiempo_standar = response.data.data.tiempo_standar;
                    }
                ).catch(
                    error => {
                        console.log(error)
                    }
                );
            axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}mod`)
                .then(
                    response => {
                        this.costo_hora_hombre_cif = response.data;
                        console.log('producto Hora Hombre CIF')
                        console.log(this.costo_hora_hombre_cif);
                    }
                ).catch(
                    error => {
                        console.log(error);
                    }
                )
        },
        getCifByProducts() {
            axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
                .then(response => {
                    this.cifByProducts = response.data.data.cifcostos
                })
                .catch(error => console.log(error))
        },
        getCifDetails() {
            axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}cif`)
                .then(
                    response => {
                        this.listaCif = response.data
                    }
                ).catch(
                    error => console.log(error)
                )
        },
        reloadData(value) {
            if (value === true) {
                this.getCifByProducts()
                this.getCifDetails()
                this.$emit('reloadData', true)
                value = false
            } else {
                console.log('Ocurrio un error')
            }
        },
        filterCifList(id) {
            let data
            data = this.listaCif.find(cif => { return cif.id == id })
            return data
        },
    },
    created() {
        this.getCifByProducts(),
        this.getCifDetails()
        this.calcCostoTotal
        this.getDataToCif()
        this.getCifs()
    },
}
</script>

<style>
th {
    height: 40px;
}

td {
    margin: 10px 0px;
}

.container {
    padding: 4px 16px;
    border-radius: 8px;
    border: 1px solid #dbdeec;
    margin-top: 24px;
    display: flex;
    align-items: center;
}

.skeleton {
    position: relative;
    width: 100%;
    /* Ancho del skeleton */
    height: auto;
    /* Altura del skeleton */
    overflow: hidden;
    /* Oculta el desbordamiento del pseudo-elemento */
    color: transparent
}

.skeleton::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f2f2f2;
    animation: skeleton-loading 1s infinite ease-in-out;
    pointer-events: none;
    /* Evita que el pseudo-elemento bloquee las interacciones */
    z-index: 1;
    /* Asegura que el pseudo-elemento quede por encima del fondo, pero no del contenido */
}

@keyframes skeleton-loading {
    0% {
        opacity: 0.7;
        /* Opacidad inicial del skeleton */
    }

    50% {
        opacity: 0.4;
        /* Opacidad intermedia del skeleton */
    }

    100% {
        opacity: 0.7;
        /* Opacidad final del skeleton */
    }
}
.rotate-180 {
  transform: rotate(180deg);
}


</style>